import { createFileRoute } from "@tanstack/react-router";

import { MarketingAboutPage } from "../components/marketing/MarketingAboutPage";
import { marketingHead } from "../marketing-content/head";

export const Route = createFileRoute("/about")({
  head: () => marketingHead("/about"),
  component: MarketingAboutPage,
});
